import { render, staticRenderFns } from "./CreateCustomerVisitSubComponent.vue?vue&type=template&id=50f991d1&scoped=true&"
import script from "./CreateCustomerVisitSubComponent.vue?vue&type=script&lang=js&"
export * from "./CreateCustomerVisitSubComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f991d1",
  null
  
)

export default component.exports